module.exports = __webpack_public_path__ + "img/vip-img9.8d5233be.png";